// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xj1s","largestCol":"styles_largestCol__3p7Xz","smallestCol":"styles_smallestCol__10CHP"};